/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';
import MainProvider from '~context/MainProvider';
import { getCookie } from "~helpers/cookies";
import Body from '~pages/body';
import HeadData from '~organisms/head';
import Footer from "~molecules/footer";
import { getMarketSection } from "~helpers/getters";
import { pageTypes } from '../constants/site-settings/navigation';

export const Head = ({ pageContext }) => (
  <HeadData page={pageContext.page} siteInfo={pageContext.siteInfo} />
);

const App = ({ pageContext }) => {

  const [isAdmin, setIsAdmin] = useState(false);
  const excludeFooterFromBody = pageTypes[pageContext?.page?.template]?.excludeFooterFromBody ?? pageTypes?.default?.excludeFooterFromBody;
  const footer = pageTypes[pageContext?.page?.template]?.disableFooter || !excludeFooterFromBody
  ? null
  : getMarketSection("footer", pageContext);

  const data = useStaticQuery(graphql`
    query {
      translations: allTranslation(filter: {}) {
        edges {
          node {
            key
            language
            value
          }
        }
      }
    }
  `);

  useEffect(() => {
    if (
      typeof window !== `undefined` &&
      getCookie("showAdminBar") === "true"
    ) {
      setIsAdmin(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  
  return (
    <MainProvider value={{ admin: isAdmin , translations: data.translations, language: pageContext.page?.language }}>
      <div
        dir={
          (pageContext.page?.language === 'ar')
            ? 'rtl'
            : 'ltr'
        }
        id="container-modules"
      >
        <Body pageContext={pageContext} />
      </div>
      {excludeFooterFromBody && <Footer footerTemplate={footer?.style} template={pageContext?.page?.template} section={footer} />}

    </MainProvider>
  );
};

App.propTypes = {
  pageContext: PropTypes.shape({
    siteName: PropTypes.string,
    isTracker: PropTypes.bool,
    isPreview: PropTypes.bool,
    page: PropTypes.shape({
      id: PropTypes.number,
      path: PropTypes.string,
    }),
    translations: PropTypes.object,
    siteInfo: PropTypes.shape({
      robots_txt: PropTypes.string,
      site_logo: PropTypes.string,
      site_name: PropTypes.string,
    }),
    siteSchema: PropTypes.shape({
      site_name: PropTypes.string,
    }),
  }),
};

export default App;
